/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_DescriptionInputs */



/**
* | output |
* | --- |
* | "Load separated audio tracks to mix under the video while you preview." |
*
* @param {Audio_Stems_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_description = /** @type {((inputs?: Audio_Stems_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargez des pistes audio séparées pour les mixer sous la vidéo pendant l'aperçu.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Getrennte Audiospuren laden, um sie bei der Vorschau unter das Video zu mischen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica tracce audio separate da mixare sotto il video durante l'anteprima.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузите разделённые аудиодорожки, чтобы микшировать их с видео при просмотре.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carga pistas de audio separadas para mezclarlas con el vídeo durante la vista previa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载分离的音轨，在预览时与视频一起混音。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分離した音声トラックを読み込み、プレビュー中に映像と一緒にミックスします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीव्यू के दौरान वीडियो के साथ मिक्स करने के लिए अलग की गई ऑडियो ट्रैक लोड करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregue faixas de áudio separadas para misturar com o vídeo durante a pré-visualização.")
	return /** @type {LocalizedString} */ ("Load separated audio tracks to mix under the video while you preview.")
});